import { useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import CardsSection from './components/CardsSection';
import FAQSection from './components/FAQSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '五一黑料网',
  url: typeof window !== 'undefined' ? window.location.origin : '',
  description: '五一黑料网深度挖掘瓜田爆料、黑料内幕及吃瓜事件，实时曝光五一黑料最新、今日黑料及全网热点瓜，提供最新黑料视频与每日吃瓜合集。',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: typeof window !== 'undefined' ? `${window.location.origin}/?q={search_term_string}` : '/?q={search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '五一黑料网的内容来源可靠吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们整合多渠道信息来源，包括行业内部人士爆料、公开新闻报道和网友投稿，所有内容均标注来源类型。对于未经证实的消息，我们会明确标注「待核实」，建议读者理性看待。',
      },
    },
    {
      '@type': 'Question',
      name: '如何向五一黑料网投稿或提供线索？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '您可以通过页面底部的「联系我们」模块提交线索或投稿。我们承诺对所有提供线索的用户进行严格匿名保护，绝不泄露投稿人任何信息。',
      },
    },
    {
      '@type': 'Question',
      name: '五一黑料网的内容更新频率如何？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们保持7x24小时内容更新，重大事件15分钟内响应。每日推送热点汇总和独家深度内容，确保您不会错过任何一个瓜。',
      },
    },
    {
      '@type': 'Question',
      name: '网站上的内容是否经过核实？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们设有专门的核实团队，对每条信息进行分类标记：已核实、多方印证、待核实、网友投稿。建议读者关注标注信息，结合多方信息综合判断。',
      },
    },
    {
      '@type': 'Question',
      name: '五一黑料网与其他娱乐资讯平台有何不同？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们坚持「不做搬运工，只挖真内幕」的理念，深度挖掘事件背后的真相。同时我们提供时间线梳理、人物关系图谱等专业内容，帮助读者全面了解事件全貌。',
      },
    },
  ],
};

export default function Home() {
  useEffect(() => {
    const existing = document.querySelector('script[type="application/ld+json"]');
    if (!existing) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);

      const faqScript = document.createElement('script');
      faqScript.type = 'application/ld+json';
      faqScript.textContent = JSON.stringify(faqJsonLd);
      document.head.appendChild(faqScript);
    }
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <UpdatesSection />
        <CardsSection />
        <FAQSection />
        <CommentsSection />
        <AboutSection />
        <AppSection />
        <RankingSection />
        <CarouselSection />
        <IndexSection />
        <ContactSection />
        <FeaturesSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}